/**
 * Niche Configuration
 * This file is auto-generated based on the NICHE environment variable
 * Used to replace {{NICHE}} placeholders in locale files
 * 
 * Generated at: 2026-01-29T13:40:39.399Z
 */

// Niche value from environment variable (set at build time)
export const NICHE = 'Trans'

export default NICHE
